/**
 * Keep in mind that this has to be in sync with
 * olive/library/Olive/View/Catalog/NoResults/Suggestion.php
 */

import { Filters } from '../../_flux/constants/filter/filters';
import formatToCurrency from '../currency/format_to_currency';
import { getSpeedIndexAbsoluteValue } from '../tyre_index/get_speed_index_for_absolute_value';

// when clicking on the suggestion, it'll remove the selected fitler's option
const TYPE_REMOVABLE = 0;
// when clicking on the suggestion, it'll improve the selected fitler's option
const TYPE_IMPROVABLE = 1;

/**
 * @param {string} filterValue
 * @param {string} filterType
 * @param {string} currencyIsoCode
 * @returns {string}
 */
function filterValueToFilterValueLabel(filterValue, filterType, currencyIsoCode) {
    switch (filterType) {
        case Filters.PRICE_MIN:
        case Filters.PRICE_MAX:
            return formatToCurrency(parseInt(filterValue), currencyIsoCode);

        case Filters.BUY_4_PAY_3:
        case Filters.INSTANT_CASH:
        case Filters.CLEARANCE:
        case Filters.RUN_FLAT:
        case Filters.QUALITY_SEGMENT_PREMIUM:
        case Filters.QUALITY_SEGMENT_VALUE:
        case Filters.QUALITY_SEGMENT_BUDGET:
        case Filters.PROMO_GIFT_CARD_50:
        case Filters.PROMO_GIFT_CARD_80:
        case Filters.PROMO_GIFT_CARD_100:
        case Filters.PROMO_GIFT_CARD_130:
        case Filters.PROMO_GIFT_CARD_150:
        case Filters.PROMO_GIFT_CARD_200:
        case Filters.PROMO_GIFT_CARD_250:
        case Filters.DISCOUNT_INSTANT_CASH_50:
        case Filters.DISCOUNT_INSTANT_CASH_80:
        case Filters.DISCOUNT_INSTANT_CASH_100:
        case Filters.DISCOUNT_INSTANT_CASH_120:
        case Filters.DISCOUNT_INSTANT_CASH_150:
        case Filters.DISCOUNT_INSTANT_CASH_160:
        case Filters.DISCOUNT_INSTANT_CASH_200:
        case Filters.DISCOUNT_INSTANT_CASH_250:
        case Filters.DISCOUNT_INSTANT_CASH_300:
        case Filters.DISCOUNT_5_OFF:
        case Filters.DISCOUNT_10_OFF:
        case Filters.DISCOUNT_15_OFF:
        case Filters.DISCOUNT_20_OFF:
        case Filters.DISCOUNT_25_OFF:
            return 'catalog-no-results-boolean-value-' + filterType;

        case Filters.MANUFACTURER:
        case Filters.MODEL:
            return filterValue.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

        case Filters.SPEED_INDEX:
            return getSpeedIndexAbsoluteValue(filterValue);

        default:
            return filterValue;
    }
}

/**
 * @param {string} filterName
 * @returns {string}
 */
function filterNameToLabelTranslationKey(filterName) {
    return 'catalog-items-facet-label-' + filterName;
}

/**
 * @param {string} facetValue
 * @param {string} facetName
 * @param {string} currencyIsoCode
 * @returns {{type: number, facetName: string, facetValue: string, improvementLabel: string, improvementValue: string, facetNameTranslationKey: string, label: string}}
 */
function generateSuggestion(facetValue, facetName, currencyIsoCode) {
    return {
        type: TYPE_REMOVABLE,
        facetName,
        facetValue,
        improvementLabel: '',
        improvementValue: '',
        facetNameTranslationKey: filterNameToLabelTranslationKey(facetName),
        label: filterValueToFilterValueLabel(facetValue, facetName, currencyIsoCode),
    };
}

function setType(suggestion, type) {
    return Object.assign({}, suggestion, {type});
}

function setLabel(suggestion, label) {
    return Object.assign({}, suggestion, {label});
}

function setImprovementValue(suggestion, improvementValue) {
    return Object.assign({}, suggestion, {improvementValue});
}

function setImprovementLabel(suggestion, improvementLabel) {
    return Object.assign({}, suggestion, {improvementLabel});
}

function hasLabel(suggestion) {
    return suggestion.label !== '';
}

export {
    TYPE_REMOVABLE,
    TYPE_IMPROVABLE,
    filterValueToFilterValueLabel,
    generateSuggestion,
    setType,
    setLabel,
    setImprovementValue,
    setImprovementLabel,
    hasLabel
};